'use client';

import React from 'react';
import { Container, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import { convertMarkdownBolds } from '@/lib/utils';
import { useWebsite } from '../context/WebsiteContext';

const SelectableWebsiteCards = ({ className = '' }: { className?: string }) => {
    const t_page = useTranslations('pages.request_website');

    const { selectedWebsite, handleSelectedWebsite } = useWebsite();

    return (
        <Container className={`grid grid-cols-1 lg:grid-cols-4 gap-6 ${className}`} style={{
            padding: '0 !important',
            paddingLeft: '0 !important',
            paddingRight: '0 !important',
        }}>
            <div className="h-full cursor-pointer flex flex-col" onClick={() => handleSelectedWebsite(0)}>
                <Typography variant="h4" component='h2' className="text-primary-gray-950 font-bold capitalize">
                    {t_page('selectable_cards.0.title')}
                </Typography>

                <div className="border border-primary-gray-950 mt-4 rounded-lg overflow-hidden flex-1">
                    <div className={`px-6 py-2 ${selectedWebsite === 0 ? 'bg-primary-yellow-400' : 'bg-primary-gray-950'}`}>
                        <Typography variant='h5' component='h3' className={`font-bold capitalize ${selectedWebsite === 0 ? 'text-white' : 'text-primary-yellow-t'}`}>
                            {selectedWebsite === 0 ? t_page('selectable_cards.0.subtitle_selected') : t_page('selectable_cards.0.subtitle')}
                        </Typography>
                    </div>

                    <Typography variant="body1" className='text-primary-gray-950 m-6 mt-4' dangerouslySetInnerHTML={{
                        __html: convertMarkdownBolds(t_page('selectable_cards.0.text'))
                    }} />
                </div>
            </div>

            <div className="h-full cursor-pointer flex flex-col" onClick={() => handleSelectedWebsite(1)}>
                <Typography variant="h4" component='h2' className="text-primary-gray-950 font-bold capitalize">
                    {t_page('selectable_cards.1.title')}
                </Typography>

                <div className="border border-primary-gray-950 mt-4 rounded-lg overflow-hidden flex-1">
                    <div className={`px-6 py-2 ${selectedWebsite === 1 ? 'bg-primary-yellow-400' : 'bg-primary-gray-950'}`}>
                        <Typography variant='h5' component='h3' className={`font-bold capitalize ${selectedWebsite === 1 ? 'text-white' : 'text-primary-yellow-t'}`}>
                            {selectedWebsite === 1 ? t_page('selectable_cards.1.subtitle_selected') : t_page('selectable_cards.1.subtitle')}
                        </Typography>
                    </div>

                    <Typography variant="body1" className='text-primary-gray-950 m-6 mt-4' dangerouslySetInnerHTML={{
                        __html: convertMarkdownBolds(t_page('selectable_cards.1.text'))
                    }} />
                </div>
            </div>

            <div className="h-full cursor-pointer flex flex-col" onClick={() => handleSelectedWebsite(2)}>
                <Typography variant="h4" component='h2' className="text-primary-gray-950 font-bold capitalize">
                    {t_page('selectable_cards.2.title')}
                </Typography>
                
                <div className="border border-primary-gray-950 mt-4 rounded-lg overflow-hidden flex-1">
                    <div className={`px-6 py-2 ${selectedWebsite === 2 ? 'bg-primary-yellow-400' : 'bg-primary-gray-950'}`}>
                        <Typography variant='h5' component='h3' className={`font-bold capitalize ${selectedWebsite === 2 ? 'text-white' : 'text-primary-yellow-t'}`}>
                            {selectedWebsite === 2 ? t_page('selectable_cards.2.subtitle_selected') : t_page('selectable_cards.2.subtitle')}
                        </Typography>
                    </div>

                    <Typography variant="body1" className='text-primary-gray-950 m-6 mt-4' dangerouslySetInnerHTML={{
                        __html: convertMarkdownBolds(t_page('selectable_cards.2.text'))
                    }} />
                </div>
            </div>

            <div className="h-full cursor-pointer flex flex-col" onClick={() => handleSelectedWebsite(3)}>
                <Typography variant="h4" component='h2' className="text-primary-gray-950 font-bold capitalize">
                    {t_page('selectable_cards.3.title')}
                </Typography>
                
                <div className="border bg-primary-gray-950 border-primary-gray-950 mt-4 rounded-lg overflow-hidden flex-1">
                    <div className={`px-6 py-2 ${selectedWebsite === 3 ? 'bg-primary-yellow-400' : 'bg-primary-gray-950'}`}>
                        <Typography variant='h5' component='h3' className={`font-bold capitalize ${selectedWebsite === 3 ? 'text-white' : 'text-primary-yellow-t'}`}>
                            {selectedWebsite === 3 ? t_page('selectable_cards.3.subtitle_selected') : t_page('selectable_cards.3.subtitle')}
                        </Typography>
                    </div>

                    <Typography variant="body1" className='text-white m-6 mt-4' dangerouslySetInnerHTML={{
                        __html: convertMarkdownBolds(t_page('selectable_cards.3.text'))
                    }} />
                </div>
            </div>
        </Container>
    );
}

export default SelectableWebsiteCards;